<template>
  <v-dialog
    v-model="isDialogVisible"
    fullscreen
    hide-overlay
  >
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        fab
        dark
        small
        color="secondary"
        v-on="on"
      >
        <v-icon>
          {{ icons.mdiDomain }}
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('establishmentSelector.dialogTitle') }}</span>
      </v-card-title>
      <div class="pa-4">
        <SelectEstablishment @on-select="onSelectEstablishment" />
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="isDialogVisible = false"
        >
          {{ $t('establishmentSelector.closeDialog') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref } from '@vue/composition-api';
import SelectEstablishment from '@/views/tss/EstablishmentSelector/SelectEstablishment.vue';
import { mdiDomain } from '@mdi/js';

export default {
  name: 'ModalSelectEstablishment',
  components: {
    SelectEstablishment,
  },
  setup() {
    const isDialogVisible = ref(false);

    const onSelectEstablishment = () => {
      isDialogVisible.value = false;
    };

    return {
      isDialogVisible,
      onSelectEstablishment,
      icons: { mdiDomain },
    };
  },
};
</script>
